import {Component, inject, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {FFAccordionComponent} from './ff-accordion.component';

/**
 * FFAccordion content component
 */
@Component({
    selector: 'app-ff-accordion-content',
    templateUrl: './ff-accordion-content.component.html',
    styleUrl: './ff-accordion-content.component.scss',
    imports: [NgClass]
})
export class FFAccordionContentComponent {
    protected container: FFAccordionComponent = inject(FFAccordionComponent, {skipSelf: true, host: true});

    // ===============================================================
    // ===============================================================

    @Input()
    public value?: string | number;
}
